<div class="position-absolute bottom-20 end-5 z-1" *ngIf="hasAnyLegendVisible()">
  <app-legend>
    <ng-container *ngIf="providerInfo$() | async as providers">
      <app-legend-category
        *ngIf="isRoadMetricLayerVisible()"
        name="Road Hazard"
        [metric]="roadMetric()"
      ></app-legend-category>
      <app-legend-category
        *ngIf="isWeatherPredictionLayerVisible()"
        name="Weather Prediction"
        [metric]="weatherPreditionMetric()"
      ></app-legend-category>
      <app-legend-category
        *ngIf="isOneVehicleDataLayerVisible()"
        name="Standard Vehicle"
        [metric]="vehicleDataMetric()"
      ></app-legend-category>
    </ng-container>
  </app-legend>
</div>
